import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DiseaseWithSynonymString } from '../disease-search';

@Component({
    selector: 'app-mobile-search-item',
    templateUrl: './mobile-search-item.component.html',
    styleUrls: ['./mobile-search-item.component.scss'],
})
export class MobileSearchItemComponent {
    @Input() disease: DiseaseWithSynonymString;
    @Output() clickEvent = new EventEmitter<PointerEvent>();
}
